export default __webpack_public_path__ + "static/media/smart-phone-card.c2ae5d9f.png";